import React from 'react'
import { MoodBoard, type MoodBoardImage } from 'msp-components'
import * as S from './JasminMoodBoard.styles'

const JasminMoodBoard = ({
  headline,
  link,
  images,
  bgColor
}: {
  headline?: string
  link: { href: string; text: string }
  images?: MoodBoardImage[]
  bgColor?: string
}) => {
  return (
    <MoodBoard
      headline={headline}
      link={link}
      images={images}
      imageClassName={S.imageClassName}
      bgColor={bgColor}
      headlineStyle={S.headline}
      linkColorScheme='primary'
      linkStyle={S.link}
      linkedImageStyle={S.linkedImage}
    />
  )
}

export default JasminMoodBoard
